import React, { useState, useEffect } from "react";
import FileUploader from "../FileUploader";
import { ConsultasModal } from "../ConsultasModal";

export function BlackListModal({
  isCreateBlackListModalOpen,
  setIsCreateBlackListModalOpen,
  getBlackList,
  setNeedRefetch,
  needRefetch
}) {
  useEffect(() => {
    if (needRefetch) {
      getBlackList();
      setNeedRefetch(false);
    }
  }, [needRefetch]);

  return (
    <ConsultasModal
      show={isCreateBlackListModalOpen}
      title="Criar documento na blacklist"
      titleId="consultas-blacklist-modal-title"
      onClose={() => setIsCreateBlackListModalOpen(false)}
    >
      <FileUploader
        uploadUrl={"black_list_document"}
        setNeedRefetch={setNeedRefetch}
        setIsCreateBlackListModalOpen={setIsCreateBlackListModalOpen}
      ></FileUploader>
    </ConsultasModal>
  );
}
